import React, { useState } from 'react';
import { Phone, Mail, MapPin, Instagram, Send, Clock } from 'lucide-react';
import { clinicInfo } from '../data/mock';
import { useToast } from '../hooks/use-toast';

const Contact = () => {
  const { toast } = useToast();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    // Simulate form submission
    setTimeout(() => {
      toast({
        title: 'Mensagem enviada!',
        description: 'Entraremos em contato em breve.',
      });
      setFormData({ name: '', email: '', phone: '', message: '' });
      setIsSubmitting(false);
    }, 1000);
  };

  return (
    <div>
      {/* Hero Section */}
      <section className="section-padding-small" style={{
        background: 'linear-gradient(to bottom, var(--bg-primary) 0%, var(--bg-secondary) 100%)',
        textAlign: 'center'
      }}>
        <div className="container">
          <h1 className="hero-large" style={{ marginBottom: '24px' }}>
            Entre em Contato
          </h1>
          <p className="body-large" style={{ maxWidth: '700px', margin: '0 auto', color: 'var(--text-secondary)' }}>
            Estamos prontos para cuidar do seu sorriso. Entre em contato e agende sua avaliação.
          </p>
        </div>
      </section>

      {/* Contact Info & Form */}
      <section className="section-padding" style={{ background: 'var(--bg-primary)' }}>
        <div className="container">
          <div className="grid-two-column">
            {/* Contact Information */}
            <div>
              <h2 className="heading-1" style={{ marginBottom: '32px' }}>Informações de Contato</h2>
              
              <div style={{ display: 'flex', flexDirection: 'column', gap: '32px' }}>
                <div style={{
                  border: '1px solid var(--border-light)',
                  borderRadius: '0px',
                  padding: '24px',
                  background: 'var(--bg-secondary)'
                }}>
                  <div style={{ display: 'flex', gap: '16px' }}>
                    <div style={{
                      width: '48px',
                      height: '48px',
                      border: '1px solid var(--border-medium)',
                      borderRadius: '0px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0
                    }}>
                      <Phone size={20} style={{ color: 'var(--text-primary)' }} />
                    </div>
                    <div>
                      <h3 className="heading-3" style={{ marginBottom: '8px' }}>Telefone</h3>
                      <a href={`https://wa.me/${clinicInfo.phone.replace(/[^0-9]/g, '')}`} className="body-regular" style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>
                        {clinicInfo.phoneDisplay}
                      </a>
                    </div>
                  </div>
                </div>

                <div style={{
                  border: '1px solid var(--border-light)',
                  borderRadius: '0px',
                  padding: '24px',
                  background: 'var(--bg-secondary)'
                }}>
                  <div style={{ display: 'flex', gap: '16px' }}>
                    <div style={{
                      width: '48px',
                      height: '48px',
                      border: '1px solid var(--border-medium)',
                      borderRadius: '0px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0
                    }}>
                      <Mail size={20} style={{ color: 'var(--text-primary)' }} />
                    </div>
                    <div>
                      <h3 className="heading-3" style={{ marginBottom: '8px' }}>E-mail</h3>
                      <a href={`mailto:${clinicInfo.email}`} className="body-regular" style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>
                        {clinicInfo.email}
                      </a>
                    </div>
                  </div>
                </div>

                <div style={{
                  border: '1px solid var(--border-light)',
                  borderRadius: '0px',
                  padding: '24px',
                  background: 'var(--bg-secondary)'
                }}>
                  <div style={{ display: 'flex', gap: '16px' }}>
                    <div style={{
                      width: '48px',
                      height: '48px',
                      border: '1px solid var(--border-medium)',
                      borderRadius: '0px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0
                    }}>
                      <MapPin size={20} style={{ color: 'var(--text-primary)' }} />
                    </div>
                    <div>
                      <h3 className="heading-3" style={{ marginBottom: '8px' }}>Endereço</h3>
                      <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                        {clinicInfo.address.building}<br />
                        {clinicInfo.address.street}<br />
                        {clinicInfo.address.neighborhood}, {clinicInfo.address.city} - {clinicInfo.address.state}
                      </p>
                    </div>
                  </div>
                </div>

                <div style={{
                  border: '1px solid var(--border-light)',
                  borderRadius: '0px',
                  padding: '24px',
                  background: 'var(--bg-secondary)'
                }}>
                  <div style={{ display: 'flex', gap: '16px' }}>
                    <div style={{
                      width: '48px',
                      height: '48px',
                      border: '1px solid var(--border-medium)',
                      borderRadius: '0px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0
                    }}>
                      <Clock size={20} style={{ color: 'var(--text-primary)' }} />
                    </div>
                    <div>
                      <h3 className="heading-3" style={{ marginBottom: '8px' }}>Horário</h3>
                      <p className="body-regular" style={{ color: 'var(--text-secondary)' }}>
                        {clinicInfo.hours}
                      </p>
                    </div>
                  </div>
                </div>

                <div style={{
                  border: '1px solid var(--border-light)',
                  borderRadius: '0px',
                  padding: '24px',
                  background: 'var(--bg-secondary)'
                }}>
                  <div style={{ display: 'flex', gap: '16px' }}>
                    <div style={{
                      width: '48px',
                      height: '48px',
                      border: '1px solid var(--border-medium)',
                      borderRadius: '0px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0
                    }}>
                      <Instagram size={20} style={{ color: 'var(--text-primary)' }} />
                    </div>
                    <div>
                      <h3 className="heading-3" style={{ marginBottom: '8px' }}>Instagram</h3>
                      <a href={clinicInfo.instagram} target="_blank" rel="noopener noreferrer" className="body-regular" style={{ color: 'var(--text-secondary)', textDecoration: 'none' }}>
                        {clinicInfo.instagramHandle}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div>
              <h2 className="heading-1" style={{ marginBottom: '24px' }}>Envie uma Mensagem</h2>
              <form onSubmit={handleSubmit} style={{
                border: '1px solid var(--border-light)',
                borderRadius: '0px',
                padding: '40px',
                background: 'var(--bg-secondary)'
              }}>
                <div style={{ marginBottom: '24px' }}>
                  <label htmlFor="name" className="body-regular" style={{ display: 'block', marginBottom: '8px' }}>
                    Nome completo *
                  </label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    style={{
                      width: '100%',
                      padding: '16px',
                      border: '1px solid var(--border-medium)',
                      borderRadius: '0px',
                      fontSize: '14px',
                      background: 'var(--bg-primary)',
                      color: 'var(--text-primary)'
                    }}
                  />
                </div>

                <div style={{ marginBottom: '24px' }}>
                  <label htmlFor="email" className="body-regular" style={{ display: 'block', marginBottom: '8px' }}>
                    E-mail *
                  </label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                    style={{
                      width: '100%',
                      padding: '16px',
                      border: '1px solid var(--border-medium)',
                      borderRadius: '0px',
                      fontSize: '14px',
                      background: 'var(--bg-primary)',
                      color: 'var(--text-primary)'
                    }}
                  />
                </div>

                <div style={{ marginBottom: '24px' }}>
                  <label htmlFor="phone" className="body-regular" style={{ display: 'block', marginBottom: '8px' }}>
                    Telefone *
                  </label>
                  <input
                    type="tel"
                    id="phone"
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    required
                    style={{
                      width: '100%',
                      padding: '16px',
                      border: '1px solid var(--border-medium)',
                      borderRadius: '0px',
                      fontSize: '14px',
                      background: 'var(--bg-primary)',
                      color: 'var(--text-primary)'
                    }}
                  />
                </div>

                <div style={{ marginBottom: '32px' }}>
                  <label htmlFor="message" className="body-regular" style={{ display: 'block', marginBottom: '8px' }}>
                    Mensagem *
                  </label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    required
                    rows={6}
                    style={{
                      width: '100%',
                      padding: '16px',
                      border: '1px solid var(--border-medium)',
                      borderRadius: '0px',
                      fontSize: '14px',
                      background: 'var(--bg-primary)',
                      color: 'var(--text-primary)',
                      resize: 'vertical'
                    }}
                  />
                </div>

                <button 
                  type="submit" 
                  className="btn-primary"
                  disabled={isSubmitting}
                  style={{ width: '100%' }}
                >
                  {isSubmitting ? 'Enviando...' : 'Enviar Mensagem'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section style={{ background: 'var(--bg-secondary)', padding: '0' }}>
        <div style={{ width: '100%', height: '450px', background: 'var(--bg-secondary)' }}>
          <iframe
            src={clinicInfo.mapUrl}
            width="100%"
            height="450"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
            title="Localização OdontoDentine"
          />
        </div>
      </section>
    </div>
  );
};

export default Contact;